import AppRoute from "models/AppRoute"

const NoCompanyRoute = new AppRoute({
    route: "/no-company",
    exact: true,
})

export default NoCompanyRoute
